import { Injectable } from '@angular/core';
import CustomStore, { ResolvedData } from 'devextreme/data/custom_store';
import { firstValueFrom, ReplaySubject } from 'rxjs';

import { GroupingTagItemEntity } from '../../domain/grouping-tag-item.entity';
import { GroupingTagListEntity } from './grouping-tag-list.entity';

@Injectable()
export class DxGroupingTagDataProvider {
	private dxStore: CustomStore | null = null;

	private readonly data$ = new ReplaySubject<GroupingTagListEntity>(1);

	public updateData(list: GroupingTagListEntity): void {
		this.data$.next(list);
	}

	public createDxStore(): CustomStore {
		if (!this.dxStore) {
			this.dxStore = new CustomStore({
				key: 'id',
				load: async (): Promise<ResolvedData<GroupingTagItemEntity>> => {
					const list = await firstValueFrom(this.data$);
					return Promise.resolve({
						data: list.elements.toList().toArray() || [],
						totalCount: list.totalItems,
					});
				},
			});
		}

		return this.dxStore;
	}
}
